import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';

import { Button, Row, Col, Form, setParamsFilter, ProTableOt as ProTable_ot, useProTableOt, DemoProTableOt, message, Modal, Input } from "../../../../../../templates/my-app/src/components/ui/ot"
import { useSOP } from "../controller/sop_controller";
import { useTranslation } from 'react-i18next';
import SOPModal from './sop_modal';
import FlowEngine from './FlowEngine';



const SOPDetail = ({
    propsForm,
    keyPrefix = "pmis.sop_detail",
    hasValue = false,
    onFormFinish = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    ...props
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const location = useLocation();
    const sop_detail = location.state || {}; // 使用可解構方式來讀取資料

    const [sop_data, set_sop_data] = useState([])

    const [form] = Form.useForm();

    const handleFlowNodesChange = (nodes) => {
        if(sop_data.length !== 0) {
            if(sop_data?.[0]?.flow_nodes.length !== nodes.length) {
                set_sop_data(prevData => 
                    prevData.map(prevObject => ({ 
                        ...prevObject, 
                        flow_nodes: nodes
                    }))
                )
            }
        }
    }
    const handleFlowNodesPositionChange = (nodes) => {
        set_sop_data(prevData => 
            prevData.map(prevObject => ({ 
                ...prevObject, 
                flow_nodes: prevObject.flow_nodes.map(prevNode => 
                    prevNode.id === nodes.id
                    ? { 
                        ...prevNode, 
                        position: nodes.position
                    }
                    : prevNode)
            }))
        )
    }
    const handleFlowEdgesChange = (edges) => {
        set_sop_data(prevData => 
            prevData.map(prevObject => ({ 
                ...prevObject, 
                flow_edges: edges
            }))
        )
    }
    const handleFlowNodeSelect = (data) => {
        form.setFieldsValue(data?.nodes?.[0] || {})
    }

    // 新增、刪除步驟的按鈕群組中新增的觸發事件
    const handleAddStepClick = () => {
        let node_id = uuidv4()
        let new_node = {
            id: node_id,
            data: { label: '' },
            position: { x: 0, y: 0 },
            flow_step_id: node_id,
        }
        if(sop_data.length === 0) {
            set_sop_data([
                {
                    sop_name: "",
                    person_in_charge: "",
                    average_worktime: "",
                    remark: "",
                    flow_nodes: [
                        new_node,
                    ],
                    flow_edges: [],
                }
            ])
        }
        else {
            set_sop_data(prevData => 
                prevData.map(prevObject => ({ 
                    ...prevObject, 
                    flow_nodes: [
                        ...prevObject.flow_nodes,
                        new_node
                    ]
                }))
            )   
        }
    }
    
    const onFinish = () => {
        const values = form.getFieldsValue();
        onFormFinish({
            ...values,
            flow_nodes: (sop_data?.[0]?.flow_nodes) ? sop_data?.[0]?.flow_nodes : [],
            flow_edges: (sop_data?.[0]?.flow_edges) ? sop_data?.[0]?.flow_edges : [],
        })
    }
    const onValuesChange = (e, { name, ...props }) => {
        let formValues = form.getFieldsValue()
    }
    

    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <FlowEngine 
                    // custom_nodes={[]}
                    // custom_edges={[]}
                    custom_nodes={sop_detail?.flow_nodes}
                    custom_edges={sop_detail?.flow_edges}
                    onFlowNodesChange={(nodes) => handleFlowNodesChange(nodes)}
                    onFlowEdgesChange={(edges) => handleFlowEdgesChange(edges)}
                    onFlowNodeSelect={(click_data) => {
                        handleFlowNodeSelect(click_data)
                    }}
                    onFlowNodePositionChange={(nodes) => {
                        handleFlowNodesPositionChange(nodes)
                    }}
                /> 
                <Row>
                    <Col span={24}>
                        <Form
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 18 }}
                            layout="horizontal"
                            form={form}
                            onValuesChange={onValuesChange}
                            onFinish={onFinish}
                            autoComplete="off"
                        >
                            <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Row gutter={[8, 8]}>
                                        <Col span={24}>
                                            <Form.Item
                                                hidden={true}
                                                name={"sop_id"}

                                            >
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label={t('step_name')}
                                                name={"step_name"}
                                                rules={!hasValue ? [
                                                    {
                                                        required: true,
                                                        message: "請輸入"
                                                    }
                                                ] : []}
                                            >
                                                <Input disabled={hasValue} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label={t('step_explain')}
                                                name={"step_explain"}
                                                rules={!hasValue ? [
                                                    {
                                                        required: true,
                                                        message: "請輸入"
                                                    }
                                                ] : []}
                                            >
                                                <Input disabled={hasValue} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label={t('person_in_charge')}
                                                name={"person_in_charge"}
                                                rules={!hasValue ? [
                                                    {
                                                        required: true,
                                                        message: "請輸入"
                                                    }
                                                ] : []}
                                            >
                                                <Input disabled={hasValue} />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}

export default SOPDetail;